import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TvPackage } from '../../../../../../../../../models/interface/tv/tvPackage';

@Component({
  selector: 'app-tv-packages',
  templateUrl: './tv-packages.component.html',
  styleUrls: ['./tv-packages.component.scss']
})
export class TvPackagesComponent implements OnInit {

  packages: TvPackage[];
  title: string;

  constructor(public dialogRef: MatDialogRef<TvPackagesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {title:string, packages: TvPackage[]}) {
  }

  ngOnInit() {
    this.packages = this.data.packages;
    this.title = this.data.title;
  }

}
